import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme';

/** Light/dark switch. Shared by the app header and the unauthenticated shell. */
export function ThemeToggleButton({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const toDark = theme !== 'dark';
  const label = toDark ? 'Switch to dark theme' : 'Switch to light theme';

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={toggleTheme}
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-steel-light bg-surface text-steel transition-colors hover:border-steel-soft hover:bg-steel-pale focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-azure ${className}`}
    >
      {toDark ? <Moon aria-hidden="true" className="h-5 w-5" /> : <Sun aria-hidden="true" className="h-5 w-5" />}
    </button>
  );
}
